<template>
  <v-container fluid>
    <v-form v-model="valid" class="form-signin">
      <h2 class="form-signin-heading">Please sign in</h2>
      <h3 class="form-header">Email Address</h3>
      <v-text-field
        v-model="user.username"
        type="username"
        :rules="rules.email"
        autocomplete="false"
        required
        class="form-input"
      />
      <h3 class="form-header">Password</h3>
      <v-text-field
        v-model="user.password"
        type="password"
        :rules="rules.password"
        autocomplete="false"
        required
        class="form-input"
        @keyup.enter="onLogin()"
      />
      <v-btn id="submit" color="primary" :disabled="!valid" @click="onLogin"> Sign in </v-btn>
    </v-form>
  </v-container>
</template>

<script setup>
import { ref } from 'vue';
import { useContextStore } from '@/stores/context';
import { useRoute, useRouter } from 'vue-router';

const context = useContextStore();
const router = useRouter();
const route = useRoute();

const user = ref({
  username: '',
  password: '',
});

const rules = {
  email: [v => !!v || 'Email is required'],
  password: [v => !!v || 'Password is required'],
};

const valid = ref(true);

const onLogin = () => {
  let returnPath = route.query.returnPath || '/';
  if (returnPath === '/login') returnPath = '/';
  return context.loginHardcoded(user.value).then(() => {
    router.push({ path: returnPath });
  });
};
</script>

<style lang="scss" scoped>
.form-signin {
  max-width: 33rem;
  padding: 1.5rem;
  margin: 0 auto;
}
.form-signin .form-signin-heading,
.form-signin .checkbox {
  margin-bottom: 2rem;
}
.form-signin .checkbox {
  font-weight: normal;
}
.form-signin .form-control {
  position: relative;
  height: auto;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  padding: 1rem;
  font-size: 1.6rem;
}

.form-header {
  margin-bottom: 5px;
}

.form-input {
  margin-bottom: 10px;
}
.form-signin .form-control:focus {
  z-index: 2;
}
.form-signin input[type='email'] {
  margin-bottom: -0.1rem;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}
.form-signin input[type='password'] {
  margin-bottom: 1rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

:deep(.v-text-field__slot input) {
  padding-left: 5px;
}
</style>
